// extracted by mini-css-extract-plugin
module.exports = {"container":"TextArea_container__3P5wy","text":"TextArea_text__tJowh"};